if(!customElements.get('body-background')) {

  class BodyBackground extends HTMLElement {
    constructor() {
      super();
  
      // vars
      this.procent = 0;
      this.movement = 0;
      this.bg = this.querySelector('[data-body-background-image]');
      this.image = this.bg.querySelector('img');
      this.context = 'desktop';
  
      // init
      this.getContext();
      this.getMovement();
  
      // Event listeners
      if (this.image) {
        this.image.addEventListener("load", () => {
          this.getMovement();
        });
      }
  
      window.addEventListener("resize", () => {
        this.getContext();
        this.getMovement();
      });
  
      lmScroll.on('scroll', (args) => {
        this.handleScroll(args);
      });
  
    }
  
    getContext() {
      var isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ||
          window.innerWidth < 768;
      var isTablet = ( /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ) && window.innerWidth < 1024;
      if (isMobile) {
        this.context = 'phone';
      } else if (isTablet) {
        this.context = 'tablet';
      } else {
        this.context = 'desktop';
      }
    }
  
    getMovement() {
  
      // do nothing if no image
      if (!this.image) {
        return false;
      }
  
      let height = this.bg.clientHeight,
          windowHeight = window.innerHeight;
  
      // Callculate movement size so animation doens't goes to quick or to slow\
      let movement = height - windowHeight;
          movement = movement < (windowHeight * 1.0) ? windowHeight * 1.0 : movement;
          movement = movement > (windowHeight * 2.5) ? windowHeight * 2.5 : movement;
      this.movement = movement;
    }
  
    handleScroll(args) {
  
      // calculate scroll position
      let y = Math.round(args.scroll.y * 100) / 100, // Scroll pos
          max = args.limit.y, // Page length,
          procent = Math.round( (y / max) * 100 ) / 100;
  
      // only animate on desktop
      if (this.context != 'desktop') {
        procent = 0;
      }
  
      // Stop function if scroll not is updated
      if (this.procent == procent) {
        return false;
      }
  
      // Update background
      this.procent = procent;
      this.updatePosition();
  
    }
  
    updatePosition() {
  
      // stop function if no image or no movement size
      if (!this.image || !this.movement) {
        return false;
      }
  
      // callculate background position top
      let top = Math.round( (this.procent * this.movement) / 10 ) * 10;
  
      // update background position
      this.bg.style.transform = `matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -${top}, 0, 1)`;
  
    }
  
  }

  window.BodyBackground = BodyBackground;
  
  customElements.define('body-background', BodyBackground);

}